<div class="mt-24">
  <div class="filter">
    <div class="grid grid--va-bottom">
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>ФИО</label>
          <input type="text" class="input-text" fieldTrim id="userName" [disabled]="isOneUserDisplay" [(ngModel)]="filterData.selected.userSelected" placeholder="Искать по ФИО" />
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Телефон</label>
          <input
            type="text"
            id="userPhone"
            class="input-text"
            prefix="+7 "
            mask="000 000-00-00"
            [disabled]="isOneUserDisplay"
            [showMaskTyped]="true"
            [(ngModel)]="filterData.selected.phone"
          />
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Компания</label>
          <app-select-multiple
            [initByKey]="'campaign_id'"
            [items]="filterData.data.companiesList"
            [textKey]="'new_name'"
            [defaultText]="'Выберите компанию'"
            [isDisabled]="isOneUserDisplay"
            (callback)="onChangeCompanies($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Регион</label>
          <app-select-multiple
            [initByKey]="'name'"
            [items]="filterData.data.regionsList"
            [textKey]="'name'"
            [defaultText]="'Выберите регион'"
            [isDisabled]="isOneUserDisplay"
            (callback)="onChangeRegions($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Филиал</label>
          <app-select-multiple
            [initByKey]="'mb_id'"
            [items]="filterData.data.branchesList"
            [textKey]="'mb_name'"
            [defaultText]="'Выберите филиал'"
            [isDisabled]="isOneUserDisplay || !filterData.data.branchesList || !filterData.data.branchesList.length"
            (callback)="onChangeBranches($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Участок</label>
          <app-select-multiple
            [initByKey]="'sector_id'"
            [items]="filterData.data.sectorsList"
            [textKey]="'sector_number_str'"
            [defaultText]="'Выберите участок'"
            (callback)="onChangeSectors($event)"
            [isDisabled]="isOneUserDisplay || !filterData.data.sectorsList || !filterData.data.sectorsList.length"
          ></app-select-multiple>
        </app-field>
      </div>
    </div>
    <div class="grid grid--va-bottom mt-16">
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Статус</label>
          <app-combobox
            (callback)="onChangeUserStatus($event)"
            [items]="filterData.data.statusesList"
            [textKey]="'es_name'"
            [defaultText]="'Выберите статус'"
            [isDisabled]="isOneUserDisplay"
            [name]="'userStatus'"
          ></app-combobox>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Доступные роли</label>
          <app-select-multiple
            [initByKey]="'id'"
            [items]="filterData.data.rolesList"
            [textKey]="'name'"
            [defaultText]="'Выберите роль'"
            [isDisabled]="isOneUserDisplay"
            (callback)="onChangeRoles($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Табельный номер ВК</label>
          <input type="text" class="input-text" [disabled]="isOneUserDisplay" id="employeeNumber" fieldTrim [(ngModel)]="filterData.selected.employee_number" />
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Табельный номер подрядчика</label>
          <input type="text" class="input-text" [disabled]="isOneUserDisplay" id="personnelNumber" fieldTrim [(ngModel)]="filterData.selected.personnel_number" />
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <button class="button" type="button" id="appApplyFilterUser" (click)="filterData.onApplyFilter()" [disabled]="isOneUserDisplay">Применить</button>
          </div>
          <div class="grid__box grid__box--size-min">
            <button class="ctrl link link--dotted-blue-dark" id="appResetFilterUser" (click)="filterData.onResetFilter()" [disabled]="isOneUserDisplay">Сбросить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
